import { render, staticRenderFns } from "./CourseCalendar.vue?vue&type=template&id=06151374&scoped=true&"
import script from "./CourseCalendar.vue?vue&type=script&lang=ts&"
export * from "./CourseCalendar.vue?vue&type=script&lang=ts&"
import style0 from "./CourseCalendar.vue?vue&type=style&index=0&id=06151374&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06151374",
  null
  
)

export default component.exports